const NoPage = () => {
    return (
        <div>
            <h1>Error! Can't find the page you are looking for.</h1>
        </div>
    )
}

export default NoPage;